export default "__VITE_ASSET__BihoL47U__"